export default __webpack_public_path__ + "static/media/OpenSans-Medium.f0cdede0.ttf";